import type { Patient } from 'infrastructure/classes/patient/patient';

export const getContactOptions = (patientInfo: Patient | undefined) => {
  const contactOptions = [
    {
      label: createLabel({
        phone: patientInfo?.loginInfo?.phone,
        numberType: patientInfo?.loginInfo?.primaryNumberType,
        type: 'Primary',
      }),
      value: 'primary',
    },
  ];

  if (patientInfo?.homeNumber) {
    contactOptions.push({
      label: createLabel({
        phone: patientInfo?.homeNumber,
        numberType: patientInfo?.secondaryNumberType,
        type: 'Secondary',
      }),
      value: 'secondary',
    });
  }

  return contactOptions;
};

const createLabel = ({
  phone,
  numberType,
  type,
}: {
  phone?: string | null;
  numberType?: string | null;
  type: string;
}) => {
  const formattedPhone = phone || '';
  const formattedNumberType = numberType ? `(${numberType})` : '';

  return `Send to ${type} ${formattedPhone} ${formattedNumberType}`;
};
